import { LazyLoad } from '@petconsole/pure-fe-mui';

const VanSupplyAdmin = LazyLoad(() => import('./VanSupplyAdmin'));

export { VanSupplyAdmin };
